<script setup>
defineProps({ footer: { type: Object, default: () => ({}) } });
</script>

<template>
  <div class="bg-black text-white py-20 xl:py-[130px]">
    <Container v-editable="footer">
      <div
        class="flex flex-col xl:flex-row xl:justify-between xl:items-start xl:self-stretch gap-10"
      >
        <div>
          <BlokImage :blok="footer?.logo" />
        </div>

        <div class="grid grid-cols-2 lg:grid-cols-4 gap-10">
          <div
            v-for="column in footer?.columns"
            :key="column._uid"
            class="sm:w-44"
          >
            <div class="uppercase text-base font-helvetica-bold">
              {{ column?.heading }}
            </div>
            <div class="mt-4 flex flex-col">
              <div
                v-for="link in column.column_links"
                :key="link._uid"
                class="py-[5px]"
              >
                <BlokLink
                  :blok="link.url"
                  :is-form="link.isForm"
                  class="text-sm"
                >
                  {{ link.text }}
                </BlokLink>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-5 mt-20 xl:flex-row xl:mt-14 xl:justify-between xl:items-center xl:self-stretch"
      >
        <div class="flex flex-col gap-5 lg:flex-row xl:items-center xl:gap-6">
          <p class="text-sm">{{ footer.copyright }}</p>
          <div class="flex flex-col gap-[5px] lg:flex-row lg:gap-6">
            <BlokLink
              v-for="link in footer.policy_links"
              :key="link._uid"
              :blok="link.url"
              :is-form="link.isForm"
              class="text-sm underline font-helvetica-bold"
            >
              {{ link.text }}
            </BlokLink>
          </div>
        </div>

        <div class="flex text-sm lg:text-base gap-x-2.5">
          A part of the HVG group of companies
          <NuxtImg
            src="/img/hvg-logo.svg"
            alt="HVG Logo"
            width="182px"
            height="26px"
          />
        </div>

        <div class="flex gap-3">
          <BlokLink
            v-for="link in footer.social_links"
            :key="link._uid"
            :blok="link.url"
          >
            <BlokImage :blok="link.image" class="w-6 h-6" />
          </BlokLink>
        </div>
      </div>
    </Container>
  </div>
</template>
